let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8m1Mi")).then(() => parcelRequire('gLL5P'));